module.exports = __webpack_public_path__ + "static/media/CIPL-Logo-header.3885d178.svg";